/* eslint-disable */
import { FormEditFieldCreateDialogView, FormEditFieldDialogViewFactory, FormEditFieldUpdateDialogView, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
import { FormEditCreateUpdateNumberFieldDialogComponent } from '../../admin/form/form-edit/dialogs/fields/number/create-update/form-edit-create-update-number-field-dialog.component';
/* eslint-enable */

/**
 * Number field implementation.
 */
export class FormEditNumberFieldDialogViewFactory implements FormEditFieldDialogViewFactory {

  constructor(
    private injector: Injector,
    private cfr: ComponentFactoryResolver) {
  }

  createCreateView(): ComponentRef<FormEditFieldCreateDialogView> {
    return this.createView();
  }

  createUpdateView(): ComponentRef<FormEditFieldUpdateDialogView> {
    return this.createView();
  }

  private createView(): ComponentRef<FormEditCreateUpdateNumberFieldDialogComponent> {
    return this.cfr.resolveComponentFactory(FormEditCreateUpdateNumberFieldDialogComponent)
      .create(this.injector);
  }

}
